import type { ActiveProviderSubscription } from '@/shared/api';

export const isReadOnlyMode = (
  subscription: ActiveProviderSubscription | null | undefined
): boolean => subscription === null;
